export function isNotNull(value) {
  if(value == null){
    return false
  }

  else {
    return true
  }

}

export function lengthIsFiveOrSix(value){
  if(value.toString().length == 5 || value.toString().length == 6){
    return true
  }

  else {
    return false
  }
}